// extracted by mini-css-extract-plugin
export default {"labelIcon":"MonitoringOptionsModalContent-labelIcon-IWqDB"};